<template>
  <div class="Box">
    <div class="header">{{ this.webinfo.websiteTitle }}</div>
    <div class="container">
      <swiper :options="mySwiperOption" v-if="bannerList.length > 0">
        <swiper-slide v-for=" (item, index) in bannerList" :key="index">
          <img :src="'dev-api' + item.bannerUrl" width="94%" height="200px" @click="onClick(index)" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="title">项目简介</div>
    <div class="content" v-html="webinfo.websiteContent">
    </div>
    <!-- 第一个echarts图 -->
    <div class="title">项目进度统计图</div>
    <div class="selectBox">
      项目区：
      <el-select style="width: 40%;" v-model="planningId" size="mini" placeholder="请选择项目规划区">
        <el-option v-for="item in planningList" :key="item.planningId" :label="item.planningName"
          :value="item.planningId">
        </el-option>
      </el-select>
    </div>
    <div id="project" ref="project" style="width: 94%; min-height: 400px; margin: auto;"></div>

    <!-- 第二个echarts图 -->
    <div class="title">施工进度统计图</div>
    <div class="selectBox1">
      <div>
        项目标段：
        <el-select style="width: 50%;" v-model="queryParams1.sectionId" size="mini" placeholder="请选择项目标段"
          @change="handchange1()">
          <el-option v-for="item in sectionList1" :key="item.sectionId" :label="item.sectionName" :value="item.sectionId">
          </el-option>
        </el-select>
      </div>
      <div>
        施工项目：
        <el-select style="width: 50%;" v-model="queryParams1.constructionId" size="mini" placeholder="请选择施工项目" clearable>
          <el-option v-for="item in construction1" :key="item.constructionId" :label="item.constructionName"
            :value="item.constructionId">
          </el-option>
        </el-select>
      </div>
    </div>
    <div id="construction" ref="construction" style="width: 94%; min-height: 450px; margin: auto;"></div>

    <!-- 第三个echarts图 -->
    <div class="title">施工计划|完成统计图</div>
    <div class="selectBox1">
      <div> 项目标段：
        <el-select style="width: 50%;" v-model="queryParams2.sectionId" size="mini" placeholder="请选择项目标段"
          @change="handchange2()">
          <el-option v-for="item in sectionList2" :key="item.sectionId" :label="item.sectionName" :value="item.sectionId">
          </el-option>
        </el-select>
      </div>
      <div>
        施工项目：
        <el-select style="width: 50%;" v-model="queryParams2.constructionId" size="mini" placeholder="请选择施工项目" clearable>
          <el-option v-for="item in construction2" :key="item.constructionId" :label="item.constructionName"
            :value="item.constructionId">
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-if="weekList.length > 0">
      <div v-for="(item, index) in weekList" :key="index" class="weekBox">
        <div class="weekTitle">{{ item.name }}计划进度表</div>
        <div :id="'constructionPlan' + index" style="width: 94%; min-height: 400px; margin: auto;"></div>
      </div>
    </div>
    <div v-else class="van-empty"
      style="color: #969799;width: 94%; min-height: 600px; margin: auto;display: flex;flex-direction: column;justify-content: center;">
      <div><img src="https://img.yzcdn.cn/vant/empty-image-default.png"></div>
      <p style="margin-top: 20px;">暂无数据,加油加油^-^</p>
    </div>

  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getWebsiteInfo, getBannerList, getPlanningList, getSectionList, getConstruction, getprojectEcharts, getfillEcharts, getfillcEcharts, } from "@/api/index";
export default {
  name: 'HelloWorld',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      mySwiperOption: {
        pagination: {
          el: '.swiper-pagination', //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        //自动播放
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        //循环
        loop: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
      },
      webinfo: {
        websiteTitle: '项目名称',
        websiteContent: "项目简介内容"
      },
      bannerList: [],
      // 下拉选择框
      planningList: [],
      planningId: '',

      sectionList1: [],
      construction1: [],

      sectionList2: [],
      construction2: [],

      queryParams1: {
        sectionId: '',
        constructionId: '',
      },
      queryParams2: {
        sectionId: '',
        constructionId: '',
      },

      // echart图表
      project: {
        xdata: [],
        ydata: []
      },
      progress: {
        ydata: [],
        xdata1: [],
        xdata2: []
      },
      weekList: [],
      chart1: '',
      chart2: '',
    }
  },
  mounted() {
    this.getWebsiteInfo();
    this.getBannerList();
    this.getPlanningList();

    this.getfillcEcharts();
    this.getfillEcharts();
    this.initChart1();
  },
  methods: {
    // echarts 渲染  
    initChart1() {
      if (this.chart1 && this.chart1.dispose) {
        //移去上次渲染的结果
        this.chart1.dispose();
      }
      const eContainer = this.$refs.project;
      if (this.project.ydata.length != 0) {
        this.chart1 = this.$echarts.init(eContainer);
        const myColor = ["#855BD7",
          "#4B6FB8",
          "#0F6E43",
          "#B69C2B",
          "#2588BB",
          "#BB612D",
          "#1D9394",
          "#C24545",]
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: function (params) {
              var value = params[0].data; // 获取当前鼠标指向的柱子对应的数据值
              var name = params[0].axisValueLabel;
              return name + '<br>' + '完成率：' + value + '%'; // 返回自定义的提示信息
            }
          },
          grid: {
            top: '2%',
            left: '3%',
            right: '5%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: [
            //x轴数据设置
            {
              type: "value",
              axisLabel: {
                formatter: '{value} %',
                show: true
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                //这是x轴文字颜色
                lineStyle: {
                  color: "#4B6FB8",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              offset: 0,
              axisLabel: {
                formatter: (val) => {
                  return `${val}`;
                },
                textStyle: {
                  //这个地方颜色是支持回调函数的这种的，如果是一种颜色则可以写成： color :'#1089E7' 
                  color: function (value, index) {
                    //value, index这是传入的两个参数
                    var num = myColor.length;//得到myColor颜色数组的长度
                    return myColor[index % num];//返回颜色数组中的一个对应的颜色值
                  },
                }
              },
              axisLine: {
                //这是y轴文字颜色
                lineStyle: {
                  color: "#65C6E7",
                },
              },
              data: this.project.xdata,
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              data: this.project.ydata,
              type: "bar",
              barMaxWidth: 25,
              barMinWidth: 5,
              zlevel: 3,
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    var value = params.data; // 获取当前鼠标指向的柱子对应的数据值
                    return value + '%'; // 返回自定义的提示信息
                  }
                },
              },
              itemStyle: {
                //通常情况下：
                normal: {
                  barBorderRadius: [0, 25, 25, 0],
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    if (params.dataIndex >= myColor.length) {
                      params.dataIndex = params.dataIndex % myColor.length;
                    }
                    return myColor[params.dataIndex];
                  },
                },
              },
            },
            {
              name: '',
              type: 'bar',
              barMaxWidth: 25,
              barMinWidth: 5,
              barGap: '-100%',//进行偏移，将背景移到数据正下方
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 25, 25, 0],
                  color: 'rgba(255,255,255,0.5)'
                }
              },
              zlevel: 2,
              data: ['100', '100', '100', '100', '100'],//每项阴影显示高度
              label: {
                normal: {
                  show: false,
                  textStyle: {
                    color: '#fff',
                    fontSize: 12
                  },
                  position: 'top'
                }
              }
            }
          ],
        }
        // let g_clickTime = null;
        // let g_TimeFn = null;
        // let g_onItemName = '';
        // this.chart1.on('click', function (params) {
        //   let myDate = new Date();
        //   if (g_clickTime === null) {
        //     // 一次点击
        //     g_clickTime = myDate.getMilliseconds(); // 返回时间的毫秒。
        //     g_onItemName = params.name;
        //     // 起一个定时器，进行重置
        //     g_TimeFn = setTimeout(function () {
        //       // 单击要执行的代码
        //       g_clickTime = null;
        //     }, 300);
        //   } else {
        //     clearTimeout(g_TimeFn);
        //     // 二次点击
        //     if (Math.abs(myDate.getMilliseconds() - g_clickTime) < 300 && g_onItemName === params.name) {
        //       // 双击操作
        //       console.log(params);
        //     }
        //     g_clickTime = null;
        //   }
        // });
        this.chart1.setOption(option)
        window.addEventListener("resize", function () {
          this.chart1.setOption(option).resize();
        });
      } else {
        //没有数据的时候
        this.initInnerHTML(eContainer);
      }
    },
    initChart2() {
      if (this.chart2 && this.chart2.dispose) {
        //移去上次渲染的结果
        this.chart2.dispose();
      }
      const eContainer = this.$refs.construction;
      if (this.progress.ydata.length != 0) {
        this.chart2 = this.$echarts.init(eContainer);
        const myColor = ["#855BD7",
          "#4B6FB8",
          "#0F6E43",
          "#B69C2B",
          "#2588BB",
          "#BB612D",
          "#1D9394",
          "#C24545",]
        const option = {
          grid: {
            top: '2%',
            left: '3%',
            right: '5%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: [
            //x轴数据设置
            {
              // type: "value",
              type: 'log',
              logBase: 100, //对数轴的底数，只在对数轴中（type: 'log'）有效。
              axisLabel: {
                formatter: '{value}',
                show: true
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                //这是x轴文字颜色
                lineStyle: {
                  color: "#4B6FB8",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "category",
              offset: 0,
              axisLabel: {
                formatter: function (value) {
                  var ret = "";//拼接加\n返回的类目项  
                  var maxLength = 5;//每项显示文字个数  
                  var valLength = value.length;//X轴类目项的文字个数  
                  var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
                  if (rowN > 1)//如果类目项的文字大于3,  
                  {
                    for (var i = 0; i < rowN; i++) {
                      var temp = "";//每次截取的字符串  
                      var start = i * maxLength;//开始截取的位置  
                      var end = start + maxLength;//结束截取的位置  
                      //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
                      temp = value.substring(start, end) + "\n";
                      ret += temp; //凭借最终的字符串  
                    }
                    return ret;
                  }
                  else {
                    return value;
                  }
                },
                textStyle: {
                  //这个地方颜色是支持回调函数的这种的，如果是一种颜色则可以写成： color :'#1089E7' 
                  color: function (value, index) {
                    //value, index这是传入的两个参数
                    var num = myColor.length;//得到myColor颜色数组的长度
                    return myColor[index % num];//返回颜色数组中的一个对应的颜色值
                  },
                }
              },
              axisLine: {
                //这是x轴文字颜色
                lineStyle: {
                  color: "#65C6E7",
                },
              },
              data: this.progress.ydata,
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              data: this.progress.xdata1,
              type: "bar",
              barMaxWidth: 25,
              barMinWidth: 5,
              zlevel: 3,
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    var value = params.data; // 获取当前鼠标指向的柱子对应的数据值
                    return value; // 返回自定义的提示信息
                  }
                },
              },
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    if (params.dataIndex >= myColor.length) {
                      params.dataIndex = params.dataIndex % myColor.length;
                    }
                    return myColor[params.dataIndex];
                  },
                },
              },
            },
            {
              name: '',
              type: 'bar',
              barMaxWidth: 25,
              barMinWidth: 5,
              barGap: '-100%',//进行偏移，将背景移到数据正下方
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,0.5)'
                }
              },
              zlevel: 2,
              data: this.progress.xdata2,//每项阴影显示高度
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#fff',
                    fontSize: 12
                  },
                  position: 'insideRight',
                  formatter: function (params) {
                    var value = params.data; // 获取当前鼠标指向的柱子对应的数据值
                    return value; // 返回自定义的提示信息
                  }
                },
              },
            }
          ],
        }
        this.chart2.setOption(option)
        window.addEventListener("resize", function () {
          this.chart2.setOption(option).resize();
        });
      } else {
        //没有数据的时候
        this.initInnerHTML(eContainer);
      }
    },
    initChart3(item, index) {
      const chart = this.$echarts.init(document.getElementById('constructionPlan' + index))
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: function (params) {
            console.log(params)
            var value = params[0].data; // 获取当前鼠标指向的柱子对应的数据值
            var name = params[0].axisValueLabel;
            return name + '<br>' + '实际完成量：' + value + '<br>' + '计划完成量：' + item.average; // 返回自定义的提示信息
          }
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            formatter: '{value}',
            show: true
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            //这是x轴文字颜色
            lineStyle: {
              color: "#4B6FB8",
            },
          },
          data: item.time,
        },
        yAxis: {
          type: 'value',
          axisLine: {
            //这是x轴文字颜色
            lineStyle: {
              color: "#65C6E7",
            },
          },
          axisLabel: {
            textStyle: {
              //这个地方颜色是支持回调函数的这种的，如果是一种颜色则可以写成： color :'#1089E7' 
              color: "#ffffff"
            }
          },
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          splitLine: { show: false }
        },
        visualMap: {
          orient: "horizontal",     //图例横向展示，vertical纵向展示
          symbol: "roundRect",
          textStyle: {
            color: '#ffffff' // 将图例文字颜色设为红色
          },
          show: true,            //展示图例
          top: 10,                //图例位置
          right: 10,             //图例位置
          textGap: 10,           //图例文字距离
          itemGap: 20,           //图例之间距离
          itemWidth: 12,         //图例图形宽度
          itemHeight: 12,
          pieces: [
            { min: item.average - 0.1, label: "已完成", color: "green", symbol: "emptyCircle" },
            { min: 0, max: item.average - 0.1, label: "未完成", color: "red", symbol: "emptyCircle" }    //设置范围区域，label是图例的名称，symbol图例的形状
          ]
        },
        dataZoom: [
          {
            show: true,
            height: 5,
            xAxisIndex: [0],
            bottom: 20,
            showDetail: false,
            showDataShadow: false,
            borderColor: "transparent",
            textStyle: {
              fontSize: 0
            },
            endValue: 4,//从0开始的相当于5个
            backgroundColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            handleSize: "0%",
            handleStyle: {
              color: "#d3dee5"
            }
          }
        ],
        series: [{
          smooth: true,     //折线图展示有弧度
          symbol: "circle",
          markLine: {       //平均线设置
            silent: true,    //true 去掉鼠标悬浮该线上的动画
            symbol: "none",   //该线无样式
            label: {
              show: false     //该线上的值去掉
            },
            lineStyle: {        //设置该线样式
              normal: {
                type: "solid",
                color: "#666666"
              }
            },
            data: [{
              yAxis: item.average,    //线的值
              name: "target"
            }]
          },
          data: item.num,
          type: 'line'
        }]
      };
      chart.setOption(option)
    },
    initInnerHTML(eContainer) {
      eContainer.innerHTML = `
        <div class="van-empty" style="color: #969799;width: 94%; min-height: 100%; margin: auto;display: flex;flex-direction: column;justify-content: center;">
          <div class="van-empty__image"><img src="https://img.yzcdn.cn/vant/empty-image-default.png" ></div>
            <p class="tips" style="margin-top: 20px;">暂无数据,加油加油^-^</p>
        </div>
      `;
    },

    /** 查询项目信息 */
    getWebsiteInfo() {
      getWebsiteInfo().then(res => {
        this.webinfo = res.data.rows[0];
      });
    },
    // 查询轮播图列表
    getBannerList() {
      getBannerList().then(res => {
        this.bannerList = res.data.rows;
      })
    },
    // 查询规划区列表
    getPlanningList() {
      getPlanningList().then(res => {
        if (res.data.rows[0].planningId) {
          this.planningId = res.data.rows[0].planningId;
        }
        this.planningList = res.data.rows;
      })
    },

    // 查询项目标段列表
    getSectionList1() {
      getSectionList({
        planningId: this.planningId
      }).then(res => {
        this.sectionList1 = res.data.rows;
      })
    },
    getSectionList2() {
      getSectionList({
        planningId: this.planningId
      }).then(res => {
        this.sectionList2 = res.data.rows;
      })
    },
    // 查询施工项目列表
    getConstruction1() {
      getConstruction(this.queryParams1).then(res => {
        this.construction1 = res.data.rows;
      })
    },
    getConstruction2() {
      getConstruction(this.queryParams2).then(res => {
        this.construction2 = res.data.rows;
      })
    },

    // 项目进度统计图
    getprojectEcharts() {
      let queryParams = {
        planningId: this.planningId
      }
      getprojectEcharts(queryParams).then(res => {
        this.project = res.data;
        this.initChart1();
      })
    },
    // 施工进度统计图
    getfillcEcharts() {
      getfillcEcharts(this.queryParams1).then(res => {
        this.progress.ydata = res.data.ydata;
        res.data.xdata1.forEach((item) => {
          this.progress.xdata1.push(item == 0 ? undefined : item)
        })
        res.data.xdata2.forEach((item) => {
          this.progress.xdata2.push(item == 0 ? undefined : item)
        })
        this.initChart2();
      })
    },
    // 施工计划完成统计图
    getfillEcharts() {
      getfillEcharts(this.queryParams2).then(res => {
        this.weekList = res.data;
        this.$nextTick(() => {
          for (const index in this.weekList) {
            this.initChart3(this.weekList[index], index);
          }
        })
      })
    },
    handchange1() {
      this.queryParams1.constructionId = ''
    },
    handchange2() {
      this.queryParams2.constructionId = ''
    }
  },
  watch: {
    // watch第一次绑定值的时候不会执行监听，修改数据才会触发函数
    planningId() {
      this.getprojectEcharts();
      this.getSectionList1();
      this.getSectionList2();
      this.queryParams1 = {
        sectionId: '',
        constructionId: ''
      };
      this.queryParams2 = {
        sectionId: '',
        constructionId: ''
      };
    },
    queryParams1: {
      handler() {
        this.getConstruction1();
        this.getfillcEcharts()
      },
      deep: true // 开启深度监听
    },
    queryParams2: {
      handler() {
        this.getConstruction2();
        this.getfillEcharts()
      },
      deep: true // 开启深度监听
    },
  }
}
</script>
<style scoped>
.Box {
  width: 100%;
  height: 100%;
  background-color: #00265f;
}

.header {
  color: #ffffff;
  font-size: 22px;
  margin: 20px 0;
}

.title {
  width: 94%;
  text-align: left;
  margin: 10px auto;
  color: #ffffff;
  font-size: 18px;
}

.weektitle {
  font-size: 14px;
}

.content {
  width: 94%;
  max-height: 240px;
  overflow-y: scroll;
  margin: auto;
  margin-top: 8px;
  color: #ffffff;
  font-size: 16px;
  text-align: justify;
  text-indent: 1.5em;
}

.selectBox {
  width: 94%;
  text-align: end;
  margin: auto;
  margin-top: 8px;
  color: #ffffff;
  font-size: 16px;
}

.selectBox1 {
  width: 94%;
  margin: auto;
  margin-top: 12px;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  text-align: left;
  text-indent: 0.5em;
}

.weekBox {
  width: 94%;
  height: auto;
  margin: auto;
  text-indent: 0.6em;
}

.weekTitle {
  color: #ffffff;
  font-size: 15px;
  text-align: left;
  padding: 10px 0 0 0;

}

.timeBox {
  width: 94%;
  margin: auto;
  margin-top: 12px;
  display: flex;
  text-indent: 0.5em;
}

.timeTile {
  color: #ffffff;
  font-size: 16px;
  width: 25%;
  text-align: left;
}

.timeInput {
  width: 75%;
  height: 28px;
  line-height: 28px;
  color: #606266;
  background-color: #ffffff;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  text-align: center;
  display: inline-flex;
  justify-content: space-around;
}

.color1 {
  color: #606266;
}
</style>
